export default __webpack_public_path__ + "static/shopeePay-ab23f558650380f3553807c97dbda202.png";